import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { SearchIcon } from "../../../icons";
import { VeriHeading } from "../../common/VeriHeading";
import { Button } from "../../common/Button";

export interface TrackRecordNoResultsProps {
  clearFilters: () => void;
}

export const TrackRecordNoResults: React.FC<TrackRecordNoResultsProps> = ({
  clearFilters,
}) => {
  return (
    <Flex
      flexDirection={"column"}
      alignItems={"center"}
      py={16}
      boxShadow={1}
      border={"1px solid"}
      borderColor={"border.grey"}
      bg={"bg.white"}
    >
      <Flex
        w={"80px"}
        h={"80px"}
        borderRadius={"100%"}
        mt={2}
        bg={"bg.greyLighter"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <SearchIcon boxSize={"48px"} />
      </Flex>
      <VeriHeading textStyle={"h5"} mt={6}>
        No results found
      </VeriHeading>
      <Box
        mt={2}
        maxW={"350px"}
        w={"100%"}
        textStyle={"bodyRegular"}
        textAlign={"center"}
      >
        No results match the filter criteria. Remove filters or clear all
        filters to show results.
      </Box>
      <Box mt={4} mb={2}>
        <Box as={"span"} color={"brand.main"} textDecoration={"underline"}>
          <Button onClick={clearFilters} isLarge link>
            Clear all filters
          </Button>
        </Box>
      </Box>
    </Flex>
  );
};
